var _path, _path2, _path3, _path4, _path5, _path6, _g, _path7, _path8, _path9, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFinbookLogoBlackText(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 179,
    height: 70,
    viewBox: "0 0 179 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85.263 26.667c.435 0 .68-.249.68-.69v-2.874c0-.442-.245-.69-.68-.69H75.332c-.435 0-.68.248-.68.69V41.06c0 .443.245.691.68.691h2.993c.435 0 .68-.248.68-.69v-6.133h6.122c.435 0 .68-.249.68-.69v-2.874c0-.442-.245-.69-.68-.69h-6.122v-4.006h6.258z",
    fill: "#5F5E5E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.09 26.28h-2.72c-.436 0-.68-.248-.68-.69v-2.487c0-.442.244-.69.68-.69h2.72c.436 0 .68.248.68.69v2.486c0 .443-.244.691-.68.691zm0 15.47h-2.72c-.436 0-.68-.248-.68-.69V28.627c0-.442.244-.69.68-.69h2.72c.436 0 .68.248.68.69V41.06c0 .443-.244.691-.68.691z",
    fill: "#5F5E5E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M101.815 27.55c-1.74 0-2.898.69-3.537 1.65v-.572c0-.442-.245-.69-.68-.69h-2.721c-.436 0-.68.248-.68.69V41.06c0 .442.244.691.68.691h2.72c.436 0 .68-.249.68-.69v-7.377c0-1.63.763-2.32 1.987-2.32 1.034 0 1.823.608 1.823 1.989v7.707c0 .442.245.691.68.691h2.721c.435 0 .68-.249.68-.69v-8.067c0-3.453-1.823-5.442-4.353-5.442z",
    fill: "#5F5E5E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.322 29.228c.91-1.053 2.233-1.677 4.054-1.677 3.564 0 6.502 3.177 6.502 7.293s-2.938 7.293-6.502 7.293c-1.821 0-3.144-.624-4.054-1.677v.6c0 .441-.245.69-.68.69h-2.721c-.435 0-.68-.248-.68-.69V23.102c0-.442.245-.69.68-.69h2.721c.435 0 .68.248.68.69v6.125zm0 5.616c0 2.072 1.36 3.37 3.237 3.37 1.878 0 3.238-1.298 3.238-3.37s-1.36-3.37-3.238-3.37c-1.877 0-3.237 1.298-3.237 3.37zM138.364 34.844c0 4.116-3.21 7.293-7.21 7.293-3.999 0-7.21-3.177-7.21-7.293s3.211-7.293 7.21-7.293c4 0 7.21 3.177 7.21 7.293zm-10.339 0c0 1.961 1.361 3.26 3.129 3.26 1.769 0 3.129-1.299 3.129-3.26 0-1.962-1.36-3.26-3.129-3.26-1.768 0-3.129 1.298-3.129 3.26zM153.851 34.844c0 4.116-3.211 7.293-7.211 7.293-3.999 0-7.21-3.177-7.21-7.293s3.211-7.293 7.21-7.293c4 0 7.211 3.177 7.211 7.293zm-10.34 0c0 1.961 1.361 3.26 3.129 3.26 1.769 0 3.129-1.299 3.129-3.26 0-1.962-1.36-3.26-3.129-3.26-1.768 0-3.129 1.298-3.129 3.26z",
    fill: "#5F5E5E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m167.786 40.921-4.218-6.077 4-6.078c.299-.47.109-.828-.435-.828h-3.129c-.354 0-.626.138-.816.442l-3.51 5.559V23.103c0-.442-.245-.69-.681-.69h-2.72c-.436 0-.681.248-.681.69V41.06c0 .443.245.691.681.691h2.72c.436 0 .681-.248.681-.69v-5.368l3.782 5.616c.19.304.462.442.816.442h3.102c.544 0 .734-.359.408-.829z",
    fill: "#5F5E5E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M171.899 32.081c0-.552.435-.939 1.442-.939.625 0 1.088.276 1.278.718.191.387.327.608.735.608h2.666c.436 0 .708-.249.653-.718-.326-2.928-2.802-4.2-5.332-4.2-2.857 0-5.524 1.41-5.524 4.531 0 5.36 7.102 3.536 7.102 5.525 0 .553-.436.94-1.578.94-.817 0-1.334-.277-1.551-.746-.191-.36-.327-.58-.735-.58h-2.666c-.436 0-.708.248-.653.718.326 2.928 2.829 4.199 5.605 4.199 2.992 0 5.659-1.354 5.659-4.53 0-5.388-7.101-3.481-7.101-5.526z",
    fill: "#5F5E5E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#ayg467prfa)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 6,
    width: 51.215,
    height: 52,
    rx: 12,
    fill: "#fff"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.666 37.387c3.155.961 11.15-4.992 11.15-4.992s-6.495-2.269-12.988-2.536c-6.494-.267-5.404 7.528-5.404 7.528s4.086-.96 7.242 0z",
    fill: "url(#51z7dcftdb)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.815 40.583S25.664 43.31 24.573 52.77c0 0-3.576-18.166 18.242-20.372v8.184z",
    fill: "url(#mqtmuxpbyc)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.408 15.847v8.67s-20.835.64-24.81 12.975c0 0-4.456-20.249 24.81-21.645",
    fill: "url(#xze4yi3kad)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "51z7dcftdb",
    x1: 8.364,
    y1: 34.425,
    x2: 13.187,
    y2: 54.098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#033898"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E93F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mqtmuxpbyc",
    x1: 37.089,
    y1: 29.459,
    x2: 22.508,
    y2: 39.066,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E93F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D5AE5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "xze4yi3kad",
    x1: 32.255,
    y1: 45.213,
    x2: 51.881,
    y2: 28.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E93F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D5AE5"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "ayg467prfa",
    x: 0,
    y: 0,
    width: 69.216,
    height: 70,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.074847 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_844_52"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_844_52",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinbookLogoBlackText);
export default __webpack_public_path__ + "static/media/finbook-logo-black-text.2cf0b76a69deb800589e78e3abe0b3f0.svg";
export { ForwardRef as ReactComponent };